import UserIcon from '@/assets/user.svg?react';

import CheckoutSummary from '@/features/v2/hh/components/CheckoutSummary';
import CheckoutSummaryNote from '@/features/v2/hh/components/CheckoutSummaryNote';
import CheckoutSummarySection from '@/features/v2/hh/components/CheckoutSummarySection';
import OrderSummary from '@/features/v2/hh/components/OrderSummary';

import RadioGroupPaymentMethod from '../components/RadioGroupPaymentMethod';
import {
  ADDON_PRICES,
  ADDON_TYPE,
  DOCUMENT_PRICES,
  DOCUMENT_TYPE,
  type EcommerceFormValues,
} from '../schema';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

const Step5Summary = () => {
  const { i18n } = useLingui();
  const { watch } = useFormContext<EcommerceFormValues>();

  const {
    billing_first_name,
    billing_last_name,
    billing_phone,
    billing_email,
    street,
    building_number,
    apartment_number,
    postal_code,
    city,
    is_company,
    company_name,
    tax_id,
    invoice_street,
    invoice_building_number,
    invoice_apartment_number,
    invoice_postal_code,
    invoice_city,
  } = watch() as EcommerceFormValues;

  const addressLine = [
    street,
    [building_number, apartment_number].filter(Boolean).join('/'),
  ]
    .filter(Boolean)
    .join(' ');
  const addressLine2 = [postal_code, city].filter(Boolean).join(' ');

  const invoiceAddressLine = [
    invoice_street,
    [invoice_building_number, invoice_apartment_number]
      .filter(Boolean)
      .join('/'),
  ]
    .filter(Boolean)
    .join(' ');
  const invoiceAddressLine2 = [invoice_postal_code, invoice_city]
    .filter(Boolean)
    .join(' ');

  return (
    <CheckoutSummary
      className="p-[14px] md:p-6"
      note={
        <CheckoutSummaryNote className="px-4 py-3 lg:px-6 lg:py-3">
          {i18n.t('Wybierz metodę płatności na stronie operatora płatności.')}
        </CheckoutSummaryNote>
      }
    >
      <OrderSummary
        documentTypes={[
          {
            value: DOCUMENT_TYPE.TEMPLATE,
            title: i18n.t('Szablon do samodzielnego wypełnienia'),
            price: DOCUMENT_PRICES[DOCUMENT_TYPE.TEMPLATE],
          },
          {
            value: DOCUMENT_TYPE.ONLINE,
            title: i18n.t('Dokument generowany online'),
            price: DOCUMENT_PRICES[DOCUMENT_TYPE.ONLINE],
          },
        ]}
        addons={[
          {
            value: ADDON_TYPE.PDF_INSTRUCTION,
            title: i18n.t('Instrukcja PDF'),
            price: ADDON_PRICES[ADDON_TYPE.PDF_INSTRUCTION],
          },
          {
            value: ADDON_TYPE.CONSULTATION,
            title: i18n.t('Konsultacja z prawnikiem'),
            price: ADDON_PRICES[ADDON_TYPE.CONSULTATION],
          },
        ]}
      />

      <CheckoutSummarySection
        icon={<UserIcon width={16} className="shrink-0 text-primary" />}
        title={i18n.t('Dane kupującego')}
      >
        <div className="caption-large flex flex-col gap-1 text-dark-gray-500">
          <p>
            {billing_first_name} {billing_last_name}
          </p>
          {billing_phone && <p>{billing_phone}</p>}
          {billing_email && <p>{billing_email}</p>}
          {addressLine && <p>{addressLine}</p>}
          {addressLine2 && <p>{addressLine2}</p>}
          {is_company && company_name && <p>{company_name}</p>}
          {is_company && tax_id && <p>{tax_id}</p>}
          {is_company && invoiceAddressLine && <p>{invoiceAddressLine}</p>}
          {is_company && invoiceAddressLine2 && <p>{invoiceAddressLine2}</p>}
        </div>
      </CheckoutSummarySection>

      <RadioGroupPaymentMethod />
    </CheckoutSummary>
  );
};

export default Step5Summary;
